import * as yup from 'yup'

yup.addMethod(
  yup.string,
  'isValidJson',
  function (message = 'Invalid JSON', { excludeEmptyString = false }) {
    return this.test('isValidJson', message, function (value = '') {
      // type check only string is allowed
      if (typeof value !== 'string') {
        return this.createError({ path: this.path, message })
      }

      // Omit the validation check for Empty String
      if (excludeEmptyString === true && value === '') return true

      try {
        JSON.parse(value)
        return true
      } catch (error) {
        return this.createError({ path: this.path, message })
      }
    })
  },
)
